export enum ObligatoriskDokumentationStatusType {
    Mangler = 0,
    Godkendt = 1,
    OBS = 2
}

